import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import _ from 'lodash';
import * as moment from 'moment';
import ReactTooltip from 'react-tooltip';

import IconButton from 'material-ui/IconButton';
import IconMenu from 'material-ui/IconMenu';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';
import SaveIcon from 'material-ui/svg-icons/content/save';
import OpenInNewIcon from 'material-ui/svg-icons/action/open-in-new';


import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import RaisedButton from 'material-ui/RaisedButton';
import Checkbox from 'material-ui/Checkbox';
import TextField from 'material-ui/TextField';
import { Link } from 'react-router';
import helpers from 'helpers';
import api from 'services';

import { execute } from 'store/configureStore';
import { getLetter } from 'sagas/letters';
import * as sagaGazetters from 'sagas/gazetters';
import * as sagaLetters from 'sagas/lettersNew';

import { postGazetters, removeGazetters } from 'actions/gazetters';
import { postAnnotations, removeAnnotations } from 'actions/annotations';
import { addNotification } from 'actions/notifications/notifications';
import { removeAllCargoOrders } from 'actions/cargoes/orders';
import { removeAllVesselOrders } from 'actions/vessels/orders';

import * as actionTypes from 'constants/ActionTypes';

import UniqueGazetters from './Sidebar/UniqueGazetters';
import FiltersAnnotations from './Sidebar/FiltersAnnotations';

import ChooseContent from './Content/ChooseContent';

import AnnotateLike from './Management/AnnotateLike';
import TextEditor from './Management/TextEditor';
import AddMailRecognizeSpam from './Management/AddMailRecognizeSpam';
import HtmlContent from '../HtmlContent';

import AnnotationList from './List/Annotation';
import GazetterList from './List/Gazetter';
import ErrorBoundary from './ErrorBoundary';
import Attachments from '../Attachments';

// import Trainings from './Trainings';

import PredictorType from './PredictorType';
import SaveLink from './SaveLink';
import { withGazettersSave } from './HOC';
import ToSpamButton from '../../common/ToSpamButton';
import ArchiveLetter from '../../SingleNew/ArchiveLetter';

import { BatchProvider } from './Content/BatchContext';
import BatchManager from './Content/BatchManager';
import { getLinesToScore } from './Content/utils';
import { fetchLineScore } from 'services/gazetters';

const styles = {
    select: {
        style: {
            width: '130px',
        },
    },
    textField: {
        style: {
            width: '50px',
            marginRight: '10px',
        },
    },
    button: {
        labelStyle: { fontSize: '10px' },
        style: { height: '25px', margin: '0 10px 0 0' },
        buttonStyle: { height: '25px', lineHeight: '25px' },
    },
    checkbox: {
        style: {
            display: 'inline-block',
            width: 'auto',
            verticalAlign: 'middle',
            margin: '0 10px 0 0',
            fontSize: '12px',
        },
    },
};


class GazetterPage extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            textLetter: '',
            selectedType: '',

            withChildren: false,

            selectedServer: 'mailparse.net',

            gazetters: [],
            filteredGazetters: [],

            annotations: [],

            searchTextGazetter: '',

            typeAnnotations: 'annotate',
            timeout: 40,

            openedAttachmentsDialog: false,
            isSimpleForm: false,

            gazettersChanges: [],
            // predictor
            predictorData: null,
            predictorLoading: false,
            showUsefulLines: false,
            lineScoreData: null,
            lineScoreLoading: false,
        };

        this.selectTypeLetter = this.selectTypeLetter.bind(this);
        this.selectTypeServer = this.selectTypeServer.bind(this);

        this.updatePostGazetters = this.updatePostGazetters.bind(this);
        this.updatePostAnnotations = this.updatePostAnnotations.bind(this);

        this.changeTypeAnnotations = this.changeTypeAnnotations.bind(this);
        this.resendAnnotations = this.resendAnnotations.bind(this);
        this.filterGazetters = this.filterGazetters.bind(this);

        this.changeGazetter = this.changeGazetter.bind(this);
        this.addNewGazetter = this.addNewGazetter.bind(this);
        this.removeGazetter = this.removeGazetter.bind(this);
        this.clearGazetter = this.clearGazetter.bind(this);
        this.saveGazetters = this.saveGazetters.bind(this);

        this.renderWithAnnotationFilters = this.renderWithAnnotationFilters.bind(this);
        this.renderOriginalAnnotations = this.renderOriginalAnnotations.bind(this);

        this.changeWithChildren = this.changeWithChildren.bind(this);
        this.changeTimeout = this.changeTimeout.bind(this);

        this.saveEmailToDev = this.saveEmailToDev.bind(this);
        this.openEmailFromDev = this.openEmailFromDev.bind(this);
    }

    changeWithChildren() {
        this.setState(state => ({
            withChildren: !state.withChildren,
        }));
    }

    renderWithAnnotationFilters(levelList) {
        const { annotations } = this.props;
        const filteredAnnotations = [];

        levelList = _.cloneDeep(levelList);

        if (levelList.length === 0) {
            return;
        }

        levelList = levelList.filter((level) => {
            if (level.rulesList.length === 0) {
                return false;
            }

            level.rulesList = level.rulesList.filter(ruleInner => ruleInner._type !== '' || ruleInner.rule !== '');

            return level.rulesList.length !== 0;
        });

        levelList.forEach((level, indexLevel) => {
            level.rulesList.forEach((rule) => {
                let levels = [];

                if (rule.typeOfRule === 'single') {
                    levels = annotations.filter((annotation) => {
                        if (rule._type && rule._type !== '') {
                            if (annotation.type.toLowerCase() === rule._type.toLowerCase()) {
                                return true;
                            }
                        }

                        if (rule.rule && rule.rule !== '') {
                            if (!annotation.features.rule) {
                                return false;
                            }

                            if (annotation.features.rule.toLowerCase() === rule.rule.toLowerCase()) {
                                return true;
                            }
                        }

                        return false;
                    });
                } else {
                    levels = annotations.filter((annotation) => {
                        if (rule._type && rule._type !== '') {
                            if (annotation.type.toLowerCase().includes(rule._type.toLowerCase())) {
                                return true;
                            }
                        }

                        if (rule.rule && rule.rule !== '') {
                            if (!annotation.features.rule) {
                                return false;
                            }

                            if (annotation.features.rule.toLowerCase().includes(rule.rule.toLowerCase())) {
                                return true;
                            }
                        }

                        return false;
                    });
                }

                levels = levels.map(item => ({
                    ...item,
                    priority: indexLevel,
                    styles: {
                        ...item.styles,
                        background: rule.color === '' ? '' : rule.color,
                    },
                }));

                filteredAnnotations.push(levels);
            });
        });

        this.setState({
            annotations: _.flatten(filteredAnnotations),
        });
    }

    renderOriginalAnnotations() {
        this.setState({
            annotations: this.props.annotations,
        });
    }

    filterGazetters(text = '', gazetters = this.state.gazetters) {
        text = text.toLowerCase();

        const filteredGazetters = gazetters.filter((gazetter) => {
            if (_.has(gazetter, 'gazetteerName')
                && gazetter.gazetteerName.toLowerCase().includes(text)) {
                return true;
            }

            if (_.has(gazetter, 'value')
                && gazetter.value.toLowerCase().includes(text)) {
                return true;
            }

            return false;
        });

        this.setState({
            searchTextGazetter: text,
            filteredGazetters,
            gazetters,
        });
    }

    changeTypeAnnotations(typeAnnotations) {
        this.setState({
            typeAnnotations,
            annotations: [],
            gazetters: [],
            filteredGazetters: [],
        }, () => {
            if (typeAnnotations === 'gazetter') {
                this.updatePostAnnotations();
            } else {
                this.updatePostGazetters();
            }
        });
    }

    resendAnnotations() {
        const {
            textLetter, selectedType, selectedServer, timeout, 
        } = this.state;
        this.props.postAnnotations(
            textLetter, 
            selectedType, 
            selectedServer, 
            { 
                emailId: this.state.letter._id, 
                isSimpleForm: this.state.isSimpleForm, 
                timeout,
                subject: this.props.letter.subject,
                date: moment(this.props.letter.date).format('DD-MM-YYYY'),
            },
        );
    }

    updatePostAnnotations(textLetter = this.state.textLetter, selectedType = this.state.selectedType, selectedServer = this.state.selectedServer) {
        this.setState({
            textLetter,
            annotations: [],
            gazetters: [],
            filteredGazetters: [],
        }, () => {
            this.props.postAnnotations(
                textLetter, 
                selectedType, 
                selectedServer, 
                { 
                    emailId: this.state.letter._id, 
                    timeout: this.state.timeout,
                    isSimpleForm: this.state.isSimpleForm,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        });
    }

    updatePostGazetters(textLetter = this.state.textLetter) {
        this.setState({
            textLetter,
            gazetters: [],
            filteredGazetters: [],
            annotations: [],
        }, () => {
            this.props.postGazetters(
                textLetter, 
                {
                    isSimpleForm: this.state.isSimpleForm,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        });
    }

    selectTypeServer(e, i, choosenType) {
        if (this.state.typeAnnotations === 'gazetter') {
            this.setState({
                selectedServer: choosenType,
                timeout: choosenType === 'nata.im' ? 300 : 40,
            }, () => {
                this.resendAnnotations();
            });

            return;
        }

        this.setState({
            selectedServer: choosenType,
        });
    }

    selectTypeLetter(e, i, choosenType) {
        if (this.state.typeAnnotations === 'gazetter') {
            this.setState({
                selectedType: choosenType,
            }, () => {
                this.resendAnnotations();
            });

            return;
        }

        this.setState({
            selectedType: choosenType,
        });
    }

    addPropertiesToGazetters(gazetters) {
        const someArray = [];
        let cloneGazetters = _.cloneDeep(gazetters);

        gazetters.forEach((gazetter) => {
            someArray.push(cloneGazetters.filter(gaz => gaz.gazetteerName === gazetter.gazetteerName));

            cloneGazetters = cloneGazetters.filter(gaz => gaz.gazetteerName !== gazetter.gazetteerName);
        });

        someArray.forEach((item) => {
            const color = helpers.createHashColor();

            item.forEach((one) => {
                one.color = color;
            });
        });

        return _.flatten(someArray);
    }

    saveGazetters() {
        this.saveGazettersToServer();
        this.saveGazettersToServerLegacy();
    }

    saveGazettersToServer() {
        const { gazettersChanges } = this.state;

        if (!gazettersChanges.length) {
            return this.props.addNotification({
                title: 'No changes',
                message: 'There are no changes to save.',
                level: 'info',
                _id: Math.random(),
                autoDismiss: 2,
            });
        }

        const payload = gazettersChanges.map(({
            status, value, oldValue, fileName, 
        }) => ({
            fileName,
            status,
            value,
            oldValue,
        }));

        this.props.saveMutation(payload, {
            onSuccess: () => {
                this.setState({ gazettersChanges: [] });
                this.updatePostGazetters();
            },
            onError: (error) => {
                this.props.addNotification({
                    title: 'Save Failed',
                    message: error.message || 'An unknown error occurred.',
                    level: 'error',
                    _id: Math.random(),
                    autoDismiss: 4,
                });
            },
        });
    }

    async saveGazettersToServerLegacy() {
        const { gazetters } = this.state;

        const sendGazetters = gazetters.filter(gazetter => gazetter.status);

        if (!sendGazetters.length) {
            return this.props.addNotification({
                title: 'Error',
                message: 'gazetters empty',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            });
        }

        const formatGazetter = (item, oldGazetter = null) => {
            const baseFormat = {
                fileName: item.gazetteerName,
                status: item.status,
                value: item.value.trim().replace(/(\r\n|\n|\r)/gm, ''),
            };

            const legacyFormat = {
                ...baseFormat,
                GazetterName: item.gazetteerName,
                GazetterType: item.gazetteerType,
                gazType: item.gazetteerType,
            };

            if (item.status === 'replace' && oldGazetter) {
                legacyFormat.oldValue = oldGazetter.value || '';
            }

            return { legacyFormat, newFormat: baseFormat };
        };

        const [legacyGazetters] = sendGazetters.reduce((acc, item) => {
            const oldGazetter = this.props.gazetters.find(gaz => gaz.id === item.id);
            const { legacyFormat, newFormat } = formatGazetter(item, oldGazetter);
            
            return [
                [...acc[0], legacyFormat],
                [...acc[1], newFormat],
            ];
        }, [[], []]);

        const { dispatch } = this.props;

        try {
            const response = await execute(sagaGazetters.saveGazetters, legacyGazetters);

            if (response.status === 200) {
                this.updatePostGazetters();
            }
        } catch (error) {
            this.props.addNotification({
                title: 'Error',
                message: error.message,
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            });

            dispatch({
                type: actionTypes.SAVE_GAZETTERS.FAILURE,
                errors: error.message,
            });

            return error;
        }
    }

    clearGazetter(gazetter) {
        const gazetters = this.state.gazetters.map((item, i) => {
            if (item.id === gazetter.id) {
                return {
                    ...this.props.gazetters.find(gaz => gaz.id === item.id),
                    id: item.id,
                    color: item.color,
                    status: '',
                };
            }

            return item;
        });

        this.setState(prevState => ({
            gazettersChanges: prevState.gazettersChanges.filter(change => change.id !== gazetter.id),
        }));

        this.filterGazetters(this.state.searchTextGazetter, gazetters);
    }

    removeGazetter(gazetter) {
        const { gazetters, gazettersChanges } = this.state;
        let newGazetters = [];
        let newGazettersChanges = structuredClone(gazettersChanges);

        if (gazetter.status === 'new') {
            newGazetters = gazetters.filter(item => item.id !== gazetter.id);
            newGazettersChanges = newGazettersChanges.filter(item => item.id !== gazetter.id);
        } else {
            newGazetters = gazetters.map((item) => {
                if (item.id === gazetter.id) {
                    return {
                        ...gazetter,
                        status: 'remove',
                    };
                }

                return item;
            });

            const changeIndex = newGazettersChanges.findIndex(item => item.id === gazetter.id);
            const change = {
                id: gazetter.id,
                fileName: gazetter.gazetteerName,
                status: 'remove',
                value: gazetter.value,
            };

            if (changeIndex > -1) {
                newGazettersChanges[changeIndex] = change;
            } else {
                newGazettersChanges.push(change);
            }
        }

        this.setState({ gazettersChanges: newGazettersChanges });
        this.filterGazetters(this.state.searchTextGazetter, newGazetters);
    }

    changeGazetter(gazetter) {
        const gazetters = this.state.gazetters.map((item) => {
            if (item.id === gazetter.id) {
                if (item.status !== 'new') {
                    return {
                        ...gazetter,
                        status: 'replace',
                    };
                } 
                return {
                    ...gazetter,
                };
            }

            return item;
        });

        const { gazettersChanges } = this.state;
        const newGazettersChanges = structuredClone(gazettersChanges);
        const changeIndex = newGazettersChanges.findIndex(item => item.id === gazetter.id);
        const originalGazetter = this.state.gazetters.find(g => g.id === gazetter.id);

        if (originalGazetter && originalGazetter.value === gazetter.value) {
            // value is the same as original - remove from changes if it exists
            if (changeIndex > -1) {
                newGazettersChanges.splice(changeIndex, 1);
            }
        } else {
            const change = {
                id: gazetter.id,
                fileName: gazetter.gazetteerName,
                status: 'replace',
                value: gazetter.value,
                oldValue: originalGazetter ? originalGazetter.value : undefined,
            };

            if (changeIndex > -1) {
                const existingChange = newGazettersChanges[changeIndex];
                if (existingChange.status === 'new') {
                    existingChange.value = gazetter.value;
                } else {
                    newGazettersChanges[changeIndex] = change;
                }
            } else {
                newGazettersChanges.push(change);
            }
        }

        this.setState({
            gazettersChanges: newGazettersChanges,
        });

        this.filterGazetters(this.state.searchTextGazetter, gazetters);
    }

    addNewGazetter({ 
        gazetteerName = '', gazetteerType = 'common', fileName = '', gazType = 'common', value = '',
    }) {
        if (/:/.test(value)) {
            this.props.addNotification({
                title: 'Error',
                message: 'Resticted symbol \':\'',
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            });

            this.props.dispatch({
                type: actionTypes.SAVE_GAZETTERS.FAILURE,
                errors: 'Resticted symbol \':\'',
            });

            return;
        }

        const { gazetters } = this.state;

        const newGazetter = {
            gazetteerName,
            gazetteerType,

            fileName,
            gazType,

            status: 'new',
            value,

            id: helpers.getNextId(gazetters),
        };

        gazetters.unshift(newGazetter);

        this.setState(prevState => ({
            gazettersChanges: [
                ...prevState.gazettersChanges,
                {
                    id: newGazetter.id,
                    fileName: gazetteerName || fileName,
                    value,
                    status: 'new',
                },
            ],
        }));

        this.filterGazetters(this.state.searchTextGazetter, gazetters);
    }

    changeTimeout(e, timeout) {
        this.setState({
            timeout,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        let { textLetter, selectedType } = this.state;

        if (textLetter === '' && nextProps.letter.text) {
            textLetter = nextProps.letter.text;
        }

        if (selectedType === '' && nextProps.letter.type) {
            selectedType = nextProps.letter.type;
        }

        const gazetters = _.isEqual(this.state.gazetters, nextProps.gazetters)
            ? this.state.gazetters
            : this.addPropertiesToGazetters(_.cloneDeep(nextProps.gazetters));

        this.setState({
            gazetters,
            annotations: nextProps.annotations,
            selectedType,
            textLetter,
            letter: nextProps.letter,
        }, () => {
            const { searchTextGazetter, gazetters, typeAnnotations } = this.state;

            if (typeAnnotations !== 'gazetters') {
                this.filterGazetters(searchTextGazetter, gazetters);
            }
        });
    }

    async getData() {
        try {
            const { data: letter } = await execute(getLetter, this.props.routeParams.id);
            this.setState({
                initialTextLetter: letter.text,
            });
            await execute(sagaGazetters.getListGazetters);
            await execute(
                sagaGazetters.postGazetters, 
                letter.text, 
                {
                    isSimpleForm: this.state.isSimpleForm,
                    subject: this.props.letter.subject,
                    date: moment(this.props.letter.date).format('DD-MM-YYYY'),
                },
            );
        } catch (error) {
            console.error(error);
        }
    }

    async saveEmailToDev() {
        try {
            await execute(sagaLetters.sendToDev, this.props.letter._id);
        } catch (error) {
            console.error(error);
        }
    }

    openEmailFromDev() {
        window.open(`https://anotatr.com:5001/${this.props.letter._id}`, '_blank');
    }

    UNSAFE_componentWillMount() {
        this.getData();
    }

    componentWillUnmount() {
        if (this.state.selectedType === 'vessel') {
            this.props.removeAllVesselOrders();
        } else {
            this.props.removeAllCargoOrders();
        }

        this.props.removeGazetters();
        this.props.removeAnnotations();
    }

    toggleAttachmentsDialog = () => {
        this.setState({
            openedAttachmentsDialog: !this.state.openedAttachmentsDialog,
        });
    }

    fetchPredictorType = async () => {
        const { letter, textLetter } = this.state;
        if (!letter) return;
        
        this.setState({ predictorLoading: true });
        const response = await api.fetchPredictorType({
            _id: letter._id,
            text: textLetter,
            owner: letter.owner ? letter.owner._id : undefined,
        });
        
        this.setState({
            predictorData: response.status === 200 ? response.data : null,
            predictorLoading: false,
        });
    };

    onToggleShowUsefulLines = async () => {
        const { showUsefulLines, predictorData, letter } = this.state;
        
        // If toggling OFF, just hide
        if (showUsefulLines) {
            this.setState({ showUsefulLines: false });
            return;
        }

        // Toggling ON - fetch line scores
        if (!predictorData || !letter) {
            this.setState({ showUsefulLines: true });
            return;
        }

        const linesToScore = getLinesToScore(predictorData);
        if (!linesToScore) {
            this.setState({ showUsefulLines: true });
            return;
        }

        this.setState({ showUsefulLines: true, lineScoreLoading: true });
        
        try {
            const response = await fetchLineScore(linesToScore, letter._id);
            this.setState({ 
                lineScoreData: response.data || null,
                lineScoreLoading: false,
            });
        } catch (error) {
            console.error('Failed to fetch line scores:', error);
            this.setState({ 
                lineScoreData: null,
                lineScoreLoading: false,
            });
        }
    }

    render() {
        const {
            textLetter,
            selectedType,
            selectedServer,
            typeAnnotations,
            filteredGazetters,
            searchTextGazetter,
            annotations,
            withChildren,
            timeout,
            initialTextLetter,
            openedAttachmentsDialog,
            isSimpleForm,
            gazettersChanges,

            predictorData,
            predictorLoading,
            showUsefulLines,
            lineScoreData,
            lineScoreLoading,
        } = this.state;

        console.log(gazettersChanges);

        const { letter, routeParams } = this.props;

        return (
            <BatchProvider>
                <div id='single-letter-gazetter' className='single-letter'>
                    <div className='content'>
                        <div className='management'>
                            <div className='management-children'>

                                <ErrorBoundary>
                                    <AnnotateLike
                                        changeTypeAnnotations={this.changeTypeAnnotations}
                                        isSpam={selectedType === 'spam'}
                                    />
                                </ErrorBoundary>

                                <SelectField
                                    className='btn'
                                    value={selectedType}
                                    onChange={this.selectTypeLetter}
                                    style={styles.select.style}
                                    selected
                                    fullWidth
                                >
                                    <MenuItem value='cargo' primaryText='as cargo' />
                                    <MenuItem value='vessel' primaryText='as vessel' />
                                    <MenuItem value='polza' primaryText='as polza' />
                                    <MenuItem value='sizes' primaryText='as sizes' />
                                </SelectField>

                                <SelectField
                                    className='btn'
                                    value={selectedServer}
                                    onChange={this.selectTypeServer}
                                    style={styles.select.style}
                                    selected
                                    fullWidth
                                >
                                    <MenuItem value='mailparse.net' primaryText='mailparse.net' />
                                    <MenuItem value='s11.anotatr.com' primaryText='s11.anotatr.com' />
                                    <MenuItem value='s1.anotatr.com' primaryText='s1.anotatr.com' />
                                    <MenuItem value='1-shipdev.me' primaryText='shipdev.me' />
                                    <MenuItem value='s4.anotatr.com' primaryText='s4.anotatr.com' />
                                    <MenuItem value='nata.im' primaryText='nata.im' />
                                    <MenuItem value='polza' primaryText='polza' />
                                </SelectField>

                                <TextField
                                    hintText='timeout'
                                    type='number'
                                    value={timeout}
                                    onChange={this.changeTimeout}
                                    style={styles.textField.style}
                                />

                                <Checkbox 
                                    style={styles.checkbox.style}
                                    label="simple"
                                    checked={isSimpleForm}
                                    onCheck={() => { this.setState({ isSimpleForm: !isSimpleForm }); }}
                                />

                                {
                                    typeAnnotations !== 'gazetter' ?
                                        <Checkbox
                                            style={styles.checkbox.style}
                                            label="children"
                                            checked={withChildren}
                                            onCheck={this.changeWithChildren}
                                        />
                                        :
                                        ''
                                }

                                <TextEditor
                                    textLetter={textLetter}
                                    typeAnnotations={typeAnnotations}
                                    updatePostGazetters={this.updatePostGazetters}
                                    updatePostAnnotations={this.updatePostAnnotations}
                                />

                                <Attachments 
                                    openedAttachmentsDialog={openedAttachmentsDialog}
                                    toggleAttachmentsDialog={this.toggleAttachmentsDialog}
                                    buttonStyle={styles.button.buttonStyle}
                                    labelStyle={styles.button.labelStyle}
                                    style={styles.button.style}
                                    attachments={letter.attachments}
                                />

                                <HtmlContent
                                    letter={letter}
                                />
                                <ErrorBoundary>
                                    <ArchiveLetter letter={letter} />
                                </ErrorBoundary>
                                <ReactTooltip id="spam-tooltip" effect="solid" html />

                                <span
                                    data-tip={selectedType === 'spam' ? 'Mail type <b>spam</b>, can not annotate as <b>spam</b>' : null}
                                    data-for="spam-tooltip"
                                >
                                    <RaisedButton
                                        className='btn'
                                        label='Order'
                                        labelStyle={styles.button.labelStyle}
                                        style={styles.button.style}
                                        buttonStyle={styles.button.buttonStyle}
                                        primary
                                        disabled={selectedType === 'spam'}
                                        containerElement={
                                            selectedType !== 'spam' ? (
                                                <Link 
                                                    to={{ 
                                                        pathname: `/${routeParams.id}/annotator/${selectedType}`, 
                                                        state: {
                                                            modifiedTextLetter: textLetter,
                                                            initialTextLetter,
                                                        }, 
                                                    }}
                                                />
                                            ) : <span />
                                        }
                                    />
                                </span>

                                <span
                                    data-tip={selectedType === 'spam' ? 'Mail type <b>spam</b>, can not annotate as <b>spam</b>' : null}
                                    data-for="spam-tooltip"
                                >
                                    <RaisedButton
                                        className='btn'
                                        label='Size'
                                        labelStyle={styles.button.labelStyle}
                                        style={styles.button.style}
                                        buttonStyle={styles.button.buttonStyle}
                                        primary
                                        disabled={selectedType === 'spam'}
                                        containerElement={
                                            selectedType !== 'spam' 
                                                ? <Link to={`/${routeParams.id}/size/${selectedType}`} /> 
                                                : <span />
                                        }
                                    />
                                </span>

                                <ToSpamButton
                                    letterId={letter._id}
                                    onSuccess={() => {
                                        this.getData();
                                    }}
                                    disabled={letter.type === 'spam'}
                                />

                                {
                                    typeAnnotations === 'gazetter' ?
                                        <RaisedButton
                                            className='btn'
                                            label='Resend'
                                            onClick={this.resendAnnotations}
                                            labelStyle={styles.button.labelStyle}
                                            style={styles.button.style}
                                            buttonStyle={styles.button.buttonStyle}
                                            primary
                                        />
                                        :
                                        <AddMailRecognizeSpam />
                                }

                                {/* <Trainings letter={this.state.letter} /> */}

                                {
                                    this.state.letter ?
                                        <PredictorType 
                                            type={(predictorData && predictorData.type) || ''}
                                            isLoading={predictorLoading}
                                            onFetch={this.fetchPredictorType}
                                            onToggleShowUsefulLines={this.onToggleShowUsefulLines}
                                            lineScoreLoading={lineScoreLoading}
                                            showUsefulLines={showUsefulLines}
                                            predictorData={predictorData}
                                            lineScoreData={lineScoreData}
                                            textLetter={textLetter}
                                        /> :
                                        null
                                }

                                <SaveLink />
                            </div>

                            <IconMenu
                                iconButtonElement={
                                    <IconButton
                                        style={{
                                            width: '25px',
                                            height: '25px',
                                            padding: 0,
                                            margin: '10px 10px 10px 0',
                                            verticalAlign: 'middle', 
                                            fontSize: '13px',
                                        }}
                                        iconStyle={{ width: '20px', height: '20px' }}
                                    >
                                        <MoreVertIcon />
                                    </IconButton>
                                }
                                anchorOrigin={{ horizontal: 'left', vertical: 'top' }}
                                targetOrigin={{ horizontal: 'left', vertical: 'top' }}
                            >
                                <MenuItem
                                    primaryText="Save to dev"
                                    style={{ fontSize: '13px' }}
                                    leftIcon={<SaveIcon />}
                                    onClick={this.saveEmailToDev}
                                />
                                <MenuItem
                                    primaryText="Open from dev"
                                    style={{ fontSize: '13px' }}
                                    leftIcon={<OpenInNewIcon />}
                                    onClick={this.openEmailFromDev}
                                />
                            </IconMenu>

                            <div className='subject'>SUBJECT: {letter.subject}</div>
                        </div>

                        <ErrorBoundary>
                            <ChooseContent
                                gazetters={filteredGazetters}
                                annotations={annotations}
                                textLetter={textLetter}
                                typeAnnotations={typeAnnotations}
                                selectedType={selectedType}
                                addNewGazetter={this.addNewGazetter}
                                withChildren={withChildren}
                                predictorData={predictorData}
                                showUsefulLines={showUsefulLines}
                                lineScoreData={lineScoreData}
                            />
                        </ErrorBoundary>

                        {
                            typeAnnotations === 'gazetter' ?
                                <ErrorBoundary>
                                    <AnnotationList />
                                </ErrorBoundary>
                                :
                                <ErrorBoundary>
                                    <GazetterList
                                        removeGazetter={this.removeGazetter}
                                        changeGazetter={this.changeGazetter}
                                        clearGazetter={this.clearGazetter}
                                        saveGazetters={this.saveGazetters}

                                        searchText={searchTextGazetter}
                                        gazetters={filteredGazetters}
                                        filterGazetters={this.filterGazetters}
                                    />
                                </ErrorBoundary>}
                    </div>
                    <div className='sidebar'>
                        {
                            typeAnnotations === 'gazetter' ?
                                <ErrorBoundary>
                                    <FiltersAnnotations
                                        selectedType={selectedType}
                                        annotations={annotations}
                                        renderWithAnnotationFilters={this.renderWithAnnotationFilters}
                                        renderOriginalAnnotations={this.renderOriginalAnnotations}
                                    />
                                </ErrorBoundary>
                                :
                                <ErrorBoundary>
                                    <UniqueGazetters
                                        gazetters={filteredGazetters}
                                    />
                                </ErrorBoundary>
                        }
                    </div>
                    {showUsefulLines && <BatchManager mailId={letter._id} />}
                </div>
            </BatchProvider>
        );
    }
}

export default connect(
    ({
        listGazetters, user: { isLogged }, letter, gazetters: { items: gazetters, isLoaded: isLoadedGazetters }, annotations: { items: annotations }, 
    }) => ({
        isLogged,
        letter,
        isLoadedGazetters,
        gazetters,
        annotations,
        listGazetters,
    }),
    dispatch => ({
        ...bindActionCreators({
            postGazetters,
            postAnnotations,
            addNotification,
            removeAllCargoOrders,
            removeAllVesselOrders,
            removeGazetters,
            removeAnnotations,
        }, dispatch),
        dispatch, 
    }),
)(withGazettersSave(GazetterPage));



// WEBPACK FOOTER //
// ./app/components/Letters/Single/Gazetter/Page.jsx